import React from "react";

const NavCodeTagIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="currentColor"
      className={className}
    >
      <path
        d="M13.2557 3.08594L15.2713 3.49728L11.4252 21.5964L9.40966 21.185L13.2557 3.08594ZM20.1457 12.3411L16.4539 8.64935V5.7391L23.0559 12.3411L16.4539 18.9329V16.0227L20.1457 12.3411ZM1.625 12.3411L8.22705 5.7391V8.64935L4.53525 12.3411L8.22705 16.0227V18.9329L1.625 12.3411Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default NavCodeTagIcon;
